"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.Icon = void 0;
var _mui = require("@ori-ui/mui");
var _styles = require("../SponsorInfo/styles");
const Root = exports.Root = (0, _mui.styled)(_styles.FloatingBannerRoot)(({
  theme
}) => ({
  background: theme.palette.grey[100],
  outline: `1px solid ${theme.palette.grey[400]}`
}));
const Icon = exports.Icon = (0, _mui.styled)(_styles.BannerIcon)(({
  theme
}) => ({
  svg: {
    fill: theme.palette.text.primary
  }
}));
